import React, { useEffect, useMemo, useState } from 'react';
import Modal from '../common/Modal';
import './ModalForms.css';
import { digitsOnly, formatDni } from '../../utils/formatters';

const emptyPassenger = { dni: '', name: '', surname: '', birthday: '' };

const PassengerFormModal = ({
  isOpen,
  onClose,
  client,
  initialData,
  onSave,
  submitting = false,
}) => {
  const isEditing = useMemo(() => Boolean(initialData?.id), [initialData]);
  const [formData, setFormData] = useState(emptyPassenger);

  useEffect(() => {
    if (!isOpen) return;
    if (initialData) {
      setFormData({
        dni: formatDni(initialData.dni || ''),
        name: String(initialData.name || '').toUpperCase(),
        surname: String(initialData.surname || '').toUpperCase(),
        birthday: initialData.birthday ? initialData.birthday.slice(0, 10) : '',
      });
    } else {
      setFormData(emptyPassenger);
    }
  }, [isOpen, initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextValue =
      name === 'name' || name === 'surname'
        ? String(value || '').toUpperCase()
        : name === 'dni'
          ? formatDni(value)
          : value;
    setFormData((prev) => ({ ...prev, [name]: nextValue }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!client?.id) return;
    await onSave?.({
      ...formData,
      name: String(formData.name || '').toUpperCase(),
      surname: String(formData.surname || '').toUpperCase(),
      dni: digitsOnly(formData.dni),
    });
  };

  return (
    <Modal
      title={isEditing ? 'Editar pasajero' : 'Nuevo pasajero'}
      isOpen={isOpen}
      onClose={submitting ? undefined : onClose}
      onEnter={() => handleSubmit()}
      footer={(
        <div className="modal-footer">
          <div className="footer-left" />
          <div className="footer-actions">
            <button type="button" className="btn secondary" onClick={onClose} disabled={submitting}>
              Cancelar
            </button>
            <button type="submit" form="passenger-form-modal-form" className="btn" disabled={submitting}>
              {submitting ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear')}
            </button>
          </div>
        </div>
      )}
    >
      <form id="passenger-form-modal-form" className="modal-form" onSubmit={handleSubmit}>
        <div className="form-grid two-columns">
          <label>
            Nombre
            <input name="name" value={formData.name} onChange={handleChange} required disabled={submitting} />
          </label>
          <label>
            Apellido
            <input name="surname" value={formData.surname} onChange={handleChange} required disabled={submitting} />
          </label>
          <label>
            DNI
            <input name="dni" value={formData.dni} onChange={handleChange} required disabled={submitting} />
          </label>
          <label>
            Fecha de nacimiento
            <input
              type="date"
              name="birthday"
              value={formData.birthday}
              onChange={handleChange}
              required
              disabled={submitting}
            />
          </label>
        </div>

      </form>
    </Modal>
  );
};

export default PassengerFormModal;

